import React from 'react';
import { DatePicker, Button, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

interface DateRangePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (start: Date | null, end: Date | null) => void;
  className?: string;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onChange,
  className = '',
}) => {
  const handleRangeChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (dates && dates[0] && dates[1]) {
      onChange(dates[0].toDate(), dates[1].toDate());
    } else {
      onChange(null, null);
    }
  };

  const value: [Dayjs | null, Dayjs | null] | null =
    startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null;

  return (
    <Space className={className}>
      <RangePicker
        value={value}
        onChange={handleRangeChange}
        format="YYYY-MM-DD"
        allowClear
        disabledDate={(current) => current && current > dayjs().endOf('day')}
        style={{ minWidth: 280 }}
      />
      {(startDate || endDate) && (
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={() => onChange(null, null)}
          size="small"
        >
          Clear
        </Button>
      )}
    </Space>
  );
};
